@if(pageInfo?.['title'] != 'Analytical' && pageInfo?.['title'] != 'eCommerce'){
<div class="p-b-10 m-b-10 overflow-hidden">
  <div class="row">
    <div class="col-sm-8">
      <h3 class="page-title m-0 f-s-20 f-w-600 m-b-10">
        {{ pageInfo?.['title'] }}
      </h3>
      <div class="hidden align-items-center overflow-hidden">
        <ul class="breadcrumb">
          @for (url of pageInfo?.['urls']; track url.url;let index = $index,last
          = $last ) { @if(!last){

          <li class="breadcrumb-item" [routerLink]="url.url">
            <a [routerLink]="url.url">{{ url.title }}</a>
          </li>
          }@else {
          <li class="breadcrumb-item active">{{ url.title }}</li>
          } }
        </ul>
      </div>
    </div>
  </div>
</div>
}